<div class="bg-base-100 rounded-xl shadow-lg border border-base-300 overflow-hidden flex flex-col w-full outline-none {{ rootClass() }}">
  <!-- Cabecera: icono + título + acciones + cerrar -->
  <div class="bg-gray-700 px-5 py-3 flex items-center justify-between gap-2 shrink-0">
    <div class="flex items-center gap-2 min-w-0 text-white">
      <i class="fa shrink-0 {{ icon() }}"></i>
      <h2 class="font-semibold text-sm truncate">{{ title() }}</h2>
    </div>
    <div class="flex items-center gap-1 sm:gap-2 shrink-0">
      <ng-content select="[header-actions]" />
      <button type="button" class="btn btn-sm btn-circle btn-ghost text-white hover:bg-white/10" (click)="closed.emit()" [attr.aria-label]="'DIALOG_SHELL_CLOSE' | translate">
        <i class="fa fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- Cuerpo -->
  <div class="flex-1 min-h-0 {{ bodyClass() }}">
    <ng-content />
  </div>

  <!-- Pie -->
  @if (showFooter()) {
    <div class="px-5 py-3 border-t border-base-300 flex flex-wrap justify-end gap-2 shrink-0">
      <ng-content select="[footer]" />
    </div>
  }
</div>
